export function MonthFilter(props) {
    const MONTHS = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
    ];
    //
    const eventList = props.eventList;
    //
    const lastEvent = eventList[eventList.length - 1];
    const lastEventDate = lastEvent.acf.event_date;
    //
    const lastEventYear = parseInt(lastEventDate.substring(0, 4), 10);
    const lastEventMonth = parseInt(lastEventDate.substring(4, 6), 10) - 1; // JS months are 0-based
    //
    const handlePrevMonth = () => {
        props.setCurrentMonthIndex(prev => {
            if (prev === 0) {
                props.setCurrentYear(year => year - 1); // go back a year
                return 11; // December
            }
            return prev - 1;
        });
    };
    //
    const handleNextMonth = () => {
        props.setCurrentMonthIndex(prevMonth => {
            props.setCurrentYear(prevYear => {
                const nextMonth = prevMonth === 11 ? 0 : prevMonth + 1;
                const nextYear = prevMonth === 11 ? prevYear + 1 : prevYear;

                // Block navigation past last event's month/year
                if (
                    nextYear > lastEventYear ||
                    (nextYear === lastEventYear && nextMonth > lastEventMonth)
                ) {
                    return prevYear;
                }

                return nextYear;
            });

            if (prevMonth === 11) {
                return 0; // January
            }

            return prevMonth + 1;
        });
    };
    //
    const now = new Date();
    const NOW_MONTH = now.getMonth();
    const NOW_YEAR = now.getFullYear();
    //
    const isAtCurrentMonth =
        props.currentMonthIndex === NOW_MONTH &&
        props.currentYear === NOW_YEAR;
    //
    const isAtLastMonth =
        props.currentYear > lastEventYear ||
        (props.currentYear === lastEventYear &&
            props.currentMonthIndex >= lastEventMonth);
    //
    return (
        <>
            <div className="d-flex align-items-center justify-content-between mb-4 col-12 col-md-6 col-lg-4 offset-0 offset-md-3 offset-lg-4">
                <button onClick={handlePrevMonth} disabled={isAtCurrentMonth}
                    aria-disabled={isAtCurrentMonth}><i className="fa fa-arrow-left"><span className="visually-hidden">Previous Month</span></i></button>
                <h3 className="mb-0 text-center flex-grow-1">
                    {MONTHS[props.currentMonthIndex]} {props.currentYear}
                </h3>
                <button onClick={handleNextMonth} disabled={isAtLastMonth} aria-disabled={isAtLastMonth}><i className="fa fa-arrow-right"><span className="visually-hidden">Next Month</span></i></button>
            </div>
        </>
    )
}